import { Box, CircularProgress, Paper, Typography } from "@mui/material";
import "../../assets/styles/common.css";

const TableCardNew = ({ image, count, text, customStyle, loading }) => {
  return (
    <Paper
      elevation={1}
      sx={{
        display: "flex",
        alignItems: "center",
        padding: "10px",
        justifyContent: "space-between",
        ...customStyle,
        height: "45px", // Adjust the height
        // gap: 5,
        // mx: 1,
        my: 1.5,
      }}
    >
      {/* Left side: Image */}
      {image && (
        <Box
          sx={{
            width: "30px",
            height: "30px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginRight: "10px",
          }}
        >
          {image}
        </Box>
      )}

      {/* Right side: Count and Text */}
      <Box>
        <Typography
          className="count"
          sx={{
            fontWeight: "bold",
            fontSize: "26px",
            marginBottom: -0.5,
            textAlign: "center",
          }}
        >
          {loading === "loading" ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "50px",
              }}
            >
              <CircularProgress size={20} color="info" />
            </Box>
          ) : (
            count
          )}
        </Typography>
        <Typography
          className="foot_text"
          sx={{ fontSize: "12px", color: "#666" }}
        >
          {text}
        </Typography>
      </Box>
    </Paper>
  );
};

export default TableCardNew;
